import React, { useCallback, useEffect, useState } from "react";

import styled from "styled-components/macro";

import SentResent from "Login/InstantAuth/SentResent";
import { usePaymentForm } from "Payments/PaymentPage/PaymentFormScreen/PaymentFormContext";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import ErrorMessage from "Payments/PaymentPage/Shared/ErrorMessage";
import { motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";
import { wrapLongWordsNoHyphen } from "UI/styles";

import CodeInput from "./CodeInput";
import { useSetAuthToLoggedIn } from "./useSetAuthToLoggedIn";

export default function VerifyCode({ hasAnimatedIn, resetHasAnimatedIn }) {
  const { state } = usePaymentPage();
  const { dispatch } = usePaymentForm();
  const { fundColorSafe } = state.fund;
  const { loginValue } = state.authCodeData;
  const isSignupPayment = Boolean(window.data?.paymentPageData?.signupName);
  const [codeResendCount, setCodeResendCount] = useState(0);
  const [code, setCode] = useState("");
  const [errorCode, setErrorCode] = useState(null);
  const setAuthToLoggedIn = useSetAuthToLoggedIn();

  useEffect(
    function clearErrorCode() {
      setErrorCode(null);
    },
    [code]
  );

  const composeErrorMsg = () => {
    //return "Shutup";
    if (!errorCode) return null;

    switch (errorCode) {
      case "invalidTextCode":
        return "Not quite... please verify your code and try again.";
      case "resendError":
        return "Hmm... there was a problem resending your code. Please try again, or contact help@flocknote.com";
      default:
        return "Oh no! Something went wrong. Please try again with a different phone or email or contact help@flocknote.com";
    }
  };

  const handleCodeChange = (e) => {
    const { value } = e.target;

    if (value.length > 4) return;
    setCode(value);
  };

  const handleBackButtonClick = () => {
    resetHasAnimatedIn();
    dispatch({
      type: "setFormStage",
      stage: "auth",
      value: "requestCode",
    });
  };

  const handleSkipClick = () => {
    setAuthToLoggedIn({ authSkipped: true });
  };

  const onResendComplete = useCallback(() => {
    setCodeResendCount((count) => count + 1);
    setCode("");
  }, []);

  return (
    <Wrapper>
      <TitleArea>
        <BackButton
          onClick={handleBackButtonClick}
          whileHover={{ scale: 1.1, color: fundColorSafe }}
          whileTap={{ scale: 0.9 }}
        >
          <FnrIcon fas fa-chevron-left />
        </BackButton>
        <Title>
          Enter the code <SentResent codeResendCount={codeResendCount} /> to{" "}
          <LoginValue>{loginValue}</LoginValue>.
        </Title>
      </TitleArea>

      <CodeInput
        hasAnimatedIn={hasAnimatedIn}
        code={code}
        handleCodeChange={handleCodeChange}
        setErrorCode={setErrorCode}
        onResendComplete={onResendComplete}
      />

      <ErrorMessage message={composeErrorMsg()} />

      {state.recurringPayment.recurring ? (
        <NoSkipping>Log in to make recurring payments.</NoSkipping>
      ) : isSignupPayment ? (
        <NoSkipping />
      ) : (
        <>
          {/* <SkipButtonHolder>
          <SkipButton onClick={handleSkipClick}>
            <div data-cy="fund-it-skip-and-continue-as-guest">
              {"Skip & Continue as Guest"}
            </div>
            <FnrIcon fas fa-angle-double-right />
          </SkipButton>
        </SkipButtonHolder> */}
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 14px;
`;
const TitleArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

const BackButton = styled(motion.button)`
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 20px;
  color: #828c8d;
  outline: none;
  padding: 0;
  margin: 0;
  margin-right: 14px;
  margin-top: 4px;
`;

const Title = styled.div`
  color: #333;
  font-weight: 400;
  font-size: 20px;
`;

const LoginValue = styled.span`
  ${wrapLongWordsNoHyphen};
  font-weight: 600;
`;

const SkipButton = styled(motion.button)`
  display: flex;
  align-items: center;
  appearance: none;
  gap: 5px;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  color: #828c8d;
`;

const SkipButtonHolder = styled.div`
  margin-top: 14px;
  display: flex;
  justify-content: center;
`;

const NoSkipping = styled.div`
  display: flex;
  justify-content: center;
  color: #828c8d;
  font-size: 14px;
  margin-top: 14px;
`;
